import './../css/style.css';

import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common';
import { initFormValidate } from './shared/formValidate';
import { initReCaptchaV3 } from './shared/reCaptchaV3';
import { initASwap } from './aswap';
import { initGallery } from './shared/gallery';
import { initModvideo } from './shared/modvideo';
import { initCarousel } from './shared/carousel';
import { initLocationCarousel } from './shared/locationCarousel';
import { initLoading } from './shared/loading';

declare global {
  interface Window { Alpine: typeof Alpine; }
}

window.Alpine = Alpine;
Alpine.plugin(focus);
initGallery();
initModvideo();
initCarousel();
initLocationCarousel();
Alpine.start();

gsap.registerPlugin(ScrollTrigger);

const lenis = new Lenis({
  duration: 1,
  autoRaf: true,
});
(window as any).lenis = lenis;

lenis.on('scroll', ScrollTrigger.update);

WCAG.init();
initCommon();
initFormValidate();
initReCaptchaV3();
initASwap();

document.fonts.ready.then(() => {
  initLoading();
});
